var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckBoxCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77346 8.40776L10.5059 2.44469C10.684 2.25939 10.9107 2.16675 11.186 2.16675C11.4613 2.16675 11.688 2.25939 11.8661 2.44469C12.0443 2.62998 12.1333 2.86581 12.1333 3.15217C12.1333 3.43853 12.0443 3.67436 11.8661 3.85965L5.45357 10.5302C5.25925 10.7323 5.03255 10.8334 4.77346 10.8334C4.51436 10.8334 4.28766 10.7323 4.09334 10.5302L1.56718 7.90241C1.38905 7.71712 1.29999 7.48129 1.29999 7.19493C1.29999 6.90857 1.38905 6.67274 1.56718 6.48745C1.7453 6.30215 1.97201 6.20951 2.2473 6.20951C2.52258 6.20951 2.74929 6.30215 2.92742 6.48745L4.77346 8.40776Z",
    fill: "#93B1FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxCheck);
export default __webpack_public_path__ + "static/media/CheckBoxCheck.ad2fb9e384a2d329829b9086cae8d330.svg";
export { ForwardRef as ReactComponent };